module.exports = __webpack_public_path__ + "static/media/products_services2.2aacbcd7.jpg";